import {
    initializeRealUserMonitoring,
    setUser,
} from '@eventbrite/real-user-monitoring';
import { App, User } from './models';

// This sample rate was extracted from https://docs.google.com/spreadsheets/d/1iC9LLWMwh8UmLKmhqyF90xEcb_iEOvPS4f0aFx130_o.
const SAMPLE_RATE = 10;

export const initDatadogRUM = ({ app, user }: { app: App; user: User }) => {
    initializeRealUserMonitoring({
        sessionSampleRate: SAMPLE_RATE,
        service: app.name,
        version: app.version,
    });

    setUser({
        id: user.publicId,
        name: user.fullName,
        email: user.email,
    });
};
